(() => {
  if (customElements.get("hom-navigation")) return;
  class HomNavigation extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const close = () => this.querySelectorAll("details[open]").forEach(menu => menu.open = false);
      this.addEventListener("click", event => {
        if (event.target.closest("a[href]")) close();
        const summary = event.target.closest("summary");
        if (!summary) return;
        const menu = summary.parentElement;
        if (menu.open) return;
        this.querySelectorAll("details[open]").forEach(other => {
          if (other !== menu && !other.contains(menu)) other.open = false;
        });
      }, options);
      document.addEventListener("pointerdown", event => {
        if (!this.contains(event.target)) close();
      }, options);
      this.addEventListener("keydown", event => {
        if (event.key !== "Escape") return;
        const menu = event.target.closest("details[open]");
        close();
        menu?.querySelector("summary")?.focus({ preventScroll: true });
      }, options);
      window.addEventListener("pageshow", close, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define("hom-navigation", HomNavigation);
})();
